import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Grid from '@material-ui/core/Grid'
import { RegistrationStore } from '../../stores/registration-store'

import { RegistrationForm } from './registration-form'

const styles = require('./registration-page.module.scss')

interface RegistrationPageProps extends RouteComponentProps<{ clientId: string, channelId: string }> {
    registrationStore?: RegistrationStore
}

export const RegistrationPageInner: React.FC<RegistrationPageProps> = inject(
    RegistrationStore.storeName,
)(observer(
    props => {
        const { registrationStore, match } = props
        const { openRegistrationForm, form, getPersonalDataLink } = registrationStore
        const { clientId, channelId } = match.params

        React.useEffect(() => {
            getPersonalDataLink({ clientId })
            openRegistrationForm({ clientId, channelId })
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [clientId, channelId])

        return (
            <Grid container spacing={8} justify="center">
                <Grid item xs={12} md={5} lg={4} container spacing={8}>
                    <h1 id="title" className={styles.title}>Регистрация</h1>

                    {form && (
                        <RegistrationForm />
                    )}
                </Grid>
            </Grid>
        )
    }
))

export const RegistrationPage = withRouter(RegistrationPageInner)
